// extracted by mini-css-extract-plugin
export default {"varCoolgray500":"var(--tkww-union-color-coolgray-500, var(--tkww-union-color-neutral-500, #51545C))","deleteFilterButton":"deleteFilterButton--ae8f4"};